module.exports = __webpack_public_path__ + "static/media/Vollyball-mobile.31f090d1.jpg";